module.exports = __webpack_public_path__ + "img/student@2x.f3ef3d2e.png";